const CONFIG = {
  videoData: {
    dot: {
      keyframes: [0, 163, 182, 239, 258, 296, 310, 325, 340, 371, 390],
      length: 10,
      totalTargets: 5,
      preCountdownLength: 3,
      preCountdownTarget: 3,
    },
    dial: {
      keyframes: [0, 95, 106, 170, 179, 226, 235, 263, 272, 301, 309, 317, 325, 337, 345, 370, 374, 389, 397, 419, 428, 432, 441, 471, 478, 491, 499, 513, 522, 527, 536],
      length: 15,
      totalTargets: 15,
      preCountdownLength: 3,
      preCountdownTarget: 3,
    },
    grid: {
      keyframes: [0, 238, 275, 304, 341, 399, 423, 445, 464, 527, 546, 657, 676, 734, 749, 800, 815, 828, 844],
      length: 25,
      totalTargets: 9,
      preCountdownLength: 3,
      preCountdownTarget: 3,
    }
  },
}

export { CONFIG }
